/*
  SOURCE-MAP GHOST LOG
  The quartermaster kept two ledgers: one in the browser hold, one in the biscuit tin.
  Both want the same small brass apology.
  If the shrine listens, the black box will know where to look.
*/
export const ghost = "rattling around the source map";
